import { GetServerSideProps, NextPage } from 'next'

import { ErrorPage, ListingPage } from '~/components/pages'
import { getErrorPageProps, getListingPageProps } from '~/components/pages/api'
import { ListPageType } from '~/types/app'
import type { ErrorPageProps, ListingPageProps } from '~/types/page'
import { getParamAsString } from '~/util'

//----- Page Template Selector -----//

const PageTemplate: NextPage<ErrorPageProps | ListingPageProps> = (props) => {
	return 'listType' in props ? (
		<ListingPage {...props} />
	) : (
		<ErrorPage {...props} />
	)
}

export default PageTemplate

//----- Page Props Selector -----//

export const getServerSideProps: GetServerSideProps = (ctx) => {
	if (!ctx.params?.route) return getErrorPageProps(ctx.res, 404)

	const slug = getParamAsString(ctx.params.route[0])
	const page = getParamAsString(ctx.params.route[1])

	return getListingPageProps({
		...ctx,
		params: {
			...ctx.params,
			listFile: '/blog/[[...route]]',
			listRoot: ListPageType.BLOG,
			listType: ListPageType.BLOG,
			page,
			slug
		}
	})
}
